export const TrashIcon = ({
  disabled,
  width = 18,
  height = 18,
}: {
  disabled?: boolean;
  width?: number;
  height?: number;
}) => {
  const strokeColor = disabled ? '#727272' : '#C1C1C2';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 4.0026V3.46927C10.6667 2.72253 10.6667 2.34917 10.5213 2.06395C10.3935 1.81307 10.1895 1.60909 9.93865 1.48126C9.65344 1.33594 9.28007 1.33594 8.53333 1.33594H7.46667C6.71993 1.33594 6.34656 1.33594 6.06135 1.48126C5.81046 1.60909 5.60649 1.81307 5.47866 2.06395C5.33333 2.34917 5.33333 2.72253 5.33333 3.46927V4.0026M6.66667 7.66927V11.0026M9.33333 7.66927V11.0026M2 4.0026H14M12.6667 4.0026V11.4693C12.6667 12.5894 12.6667 13.1494 12.4487 13.5773C12.2569 13.9536 11.951 14.2595 11.5746 14.4513C11.1468 14.6693 10.5868 14.6693 9.46667 14.6693H6.53333C5.41323 14.6693 4.85318 14.6693 4.42535 14.4513C4.04903 14.2595 3.74307 13.9536 3.55132 13.5773C3.33333 13.1494 3.33333 12.5894 3.33333 11.4693V4.0026"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
